export function loginRedirectState(location) {
  return {
    from: {
      pathname: location.pathname,
      search: location.search || '',
      hash: location.hash || '',
    },
  };
}

export function loginDestination(state) {
  const from = state?.from;
  if (!from?.pathname?.startsWith('/') || from.pathname.startsWith('//')) {
    return '/';
  }

  return `${from.pathname}${from.search || ''}${from.hash || ''}`;
}
